import {HttpContextToken} from '@angular/common/http';

/**
 * Set on a request via `context` to suppress the global ErrorInterceptor
 * toast for an error response the caller already handles
 * (e.g. a 404 on an empty shopping cart). Also skips the server-side error log.
 */
export const SILENT_ERROR = new HttpContextToken<boolean>(() => false);

/**
 * Set on a request via `context` to force the global ErrorInterceptor toast
 * for a client error (4xx) that would otherwise be treated as minor.
 * Server errors (5xx) and network failures (status 0) already alert by default.
 */
export const ALERT_ERROR = new HttpContextToken<boolean>(() => false);
